<template>
  <div v-if="properties.showOnlyButton" class="mb-3 pl-1 pt-1">
    <v-tooltip v-if="(hasImage && properties.deletable == true)" bottom>
      <span>{{$translate('DELETE_LOGO')}}</span>
    </v-tooltip>
    <v-flex>
      <!-- :class="[hasImage ? 'show_content' : 'not_show_content']"> -->
      <h4>{{this.pictureName}}</h4>
        <v-layout align-center justify-center row fill-height>
          <v-tooltip v-if="!hasImage || properties.deletable == false" bottom>
            <v-btn slot="activator" class="v-btn-2 addPicture" color="primary" small round @click="pickFile">
              <v-icon small>add_a_photo</v-icon>
            </v-btn>
            <span>{{imageTooltip}}</span>
          </v-tooltip>
        </v-layout>
    </v-flex>
    <input
      type="file"
      style="display: none"
      :ref="imageInput"
      accept="image/*"
      @change="onImageFilePicked"
    >
  </div>
  <div v-else class="small_border_image_loader mb-3 pl-1 pt-1">
    <h4>{{properties.title}}</h4>
    <v-tooltip v-if="!hasImage || properties.deletable == false" bottom>
      <v-btn slot="activator" class="v-btn-2" color="primary" round @click="pickFile">
        <v-icon>add_a_photo</v-icon>
      </v-btn>
      <span>{{imageTooltip}}</span>
    </v-tooltip>
    <v-tooltip v-if="(hasImage && properties.deletable == true)" bottom>
      <v-btn class="v-btn-2" round slot="activator" @click="clearImage">
        <v-icon small>delete</v-icon>
      </v-btn>
      <span>{{$translate('DELETE_LOGO')}}</span>
    </v-tooltip>
    <v-flex>
      <!-- :class="[hasImage ? 'show_content' : 'not_show_content']"> -->
      <h4>{{this.pictureName}}</h4>
      <v-img :ref="imgId" contain style="cursor:pointer;" :src="image.src" height="150"/>
    </v-flex>
    <input
      type="file"
      style="display: none"
      :ref="imageInput"
      accept="image/*"
      @change="onImageFilePicked"
    >
  </div>
</template>

<script>
import appConfig from "../../../config/app_config";

export default {
  name: "ImageLoader",
  props: {
    properties: Object
  },
  watch: {
    properties: {
      handler(data) {
        if (data.pictureUrl !== undefined && data.pictureUrl !== "") {
          this.pictureName = this.properties.pictureName;
          this.image.src = this.properties.pictureUrl;
          this.hasImage = true;
        } else {
          this.hasImage = false;
          this.pictureName = "";
          this.image.src = "";
        }
      },
      deep: true
    }
  },
  created() {
    if (
      this.properties.pictureUrl !== undefined &&
      this.properties.pictureUrl !== ""
    ) {
      this.pictureName = this.properties.pictureName;
      this.image.src = this.properties.pictureUrl;
      this.hasImage = true;
    }
  },
  data() {
    return {
      onlyButton: '',
      hasImage: false,
      image: new Image(),
      imageTooltip: "upload an image",
      pictureName: "",
      imgId: "img_" + this.properties.signalName,
      imageInput: "imageInput_" + this.properties.signalName
    };
  },
  mounted() {},
  methods: {
    pickFile() {
      this.$refs[this.imageInput].click();
    },
    clearImage() {
      this.image.src = "";
      this.pictureName = "";
      this.hasImage = false;
      this.$emit(this.properties.signalName, {
        signalName: this.properties.signalName,
        file: "",
        url: ""
      });
    },
    onImageFilePicked(a) {
      const maxSize = appConfig.maxSize.pictureSize;
      const files = a.target.files;


      if (files[0] !== undefined) {
        if (files[0].size > maxSize) {
          window.EventBus.fire(
            "activateSnackBar",
            "File can't be bigger than 1MB"
          );
          return;
        }
        this.pictureName = files[0].name;
        if (this.pictureName.lastIndexOf(".") <= 0) {
          return;
        }

        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("error", () => {
        });
        fr.addEventListener("load", () => {
          //clean first
          this.image.src = "";
          this.pictureName = "";
          this.hasImage = false;

          //reload the image
          this.image.src = fr.result;
          this.imageFile = files[0];
          this.hasImage = true;

          const o = {
            signalName: this.properties.signalName,
            file: this.imageFile,
            url: this.image.src
          };
          this.$emit(this.properties.signalName, o);
        });
      } else {
        window.EventBus.fire("activateSnackBar", "File is not available");
        this.image.src = "";
        this.imageFile = "";
        this.pictureName = "";
        this.hasImage = false;
        this.$emit(this.properties.signalName, {
          signalName: this.properties.signalName,
          file: "",
          url: ""
        });
      }
    }
  }
};
</script>

<style scope>
.v-btn-2 {
  min-width: 1em;
}

.not_show_content {
  display: block;
}
.show_content {
  display: block;
}
#fileInput {
  display: none;
}
.small_border_image_loader {
  border: 2px solid #c0c0c0 !important;
}
</style>
